import "./kakao.js";

// 사용할 앱의 JavaScript 키를 설정해 주세요.
Kakao.init('0c80f4db2437c2f568a9cc4f19e7661b');
